import { createAsyncLocalStorage } from './async-local-storage';
export const requestAsyncStorage = createAsyncLocalStorage();

//# sourceMappingURL=request-async-storage.js.map